import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import MercurXNftTable from '../../components/MercurXNftTable/MercurXNftTable';
import {
  filterNftsAction,
  getNftsActionRequest,
  sortNftsAction,
} from '../../store/nft/nftActions';
import './NFTs.scss';

function NFTs({
  getNftsRequest,
  sortNfts,
  filterNfts,
}) {
  const history = useHistory();
  const [filterInput, setFilterInput] = useState('');
  const user = JSON.parse(localStorage.getItem('user'))?.user;

  useEffect(() => {
    getNftsRequest();
  }, [getNftsRequest]);

  useEffect(() => {
    filterNfts(filterInput);
    sortNfts();
  }, [filterInput, filterNfts, sortNfts]);

  function createNewNft() {
    history.push('/nfts/create-new-nft');
  }

  return (
    <>
      <div className="text-fs-head-md mb-4">NFT List</div>
      <Row className="text-fs-body-md mt-4 text-center">
        <Col>
          <Form.Control
            className="text-fs-body-sm"
            type="text"
            placeholder="Search by NFT name, URL, address or contract address..."
            aria-label="text"
            aria-describedby="basic-addon1"
            value={filterInput}
            onChange={(e) => setFilterInput(e.target.value)}
            size={'sm'}
          />
        </Col>
      </Row>
      <div id="nfts-container" className="mt-4">
        <MercurXNftTable />
      </div>
      <div className="text-end">
        {user.is_superuser && (
          <Button onClick={createNewNft} size={'sm'}>
            Create new NFT
          </Button>
        )}
      </div>
    </>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    getNftsRequest: (payload) => {
      dispatch(getNftsActionRequest(payload));
    },
    sortNfts: (payload) => {
      dispatch(sortNftsAction(payload));
    },
    filterNfts: (payload) => {
      dispatch(filterNftsAction(payload));
    },
  };
};

export default connect(null, mapDispatchToProps)(NFTs);
